export default {
    INCLUDES_CEDECO: 'INCLUDES_CEDECO',
    INCLUDES_ESPP: 'INCLUDES_ESPP',
    MORE_THAN_100_PERCENTS: 'MORE_THAN_100_PERCENTS',
    IS_DATA_VIZ: 'IS_DATA_VIZ',
    DIFFERENT_FROM_REPORT: 'DIFFERENT_FROM_REPORT'
};
